import { render, staticRenderFns } from "./permissions.vue?vue&type=template&id=5000f126&scoped=true"
import script from "./permissions.vue?vue&type=script&lang=js"
export * from "./permissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5000f126",
  null
  
)

export default component.exports